module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/export-52ef1d0c06b177706b2a6171a942f3a3.svg";